"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHotKeys = void 0;
var _hotkeysJs = _interopRequireDefault(require("hotkeys-js"));
var _react = require("react");
var useHotKeys = exports.useHotKeys = function useHotKeys(keys, handler) {
  var memoisedHandler = (0, _react.useCallback)(function (event, _ref) {
    var key = _ref.key;
    event.preventDefault();
    return handler(key);
  }, [handler]);
  (0, _react.useEffect)(function () {
    (0, _hotkeysJs["default"])(keys, memoisedHandler);
    return function () {
      return _hotkeysJs["default"].unbind(keys, memoisedHandler);
    };
  }, [keys, memoisedHandler]);
};